import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { useMemo } from 'react';
import { useActiveAndPendingMembersCount } from './use-active-and-pending-members-count';
import { useBrowseWorkspaceMembers } from './use-browse-workspace-members';

export function useCheckLimitReached() {
  const { browseApi } = useBrowseWorkspaceMembers();
  const { data } = useCurrentSubscriptionApi();
  const { activeAndPendingMembersCount } = useActiveAndPendingMembersCount();

  const seat = Number(data?.current?.plan?.metadata.seat);
  const items = browseApi.data;
  const hasLimitReached = useMemo(() => {
    return seat ? activeAndPendingMembersCount >= seat : false;
  }, [items, seat]);

  return { hasLimitReached, seat };
}
